import DateIntervalDefinition from '../filtersDefinition/DateIntervalDefinition.js';
import ColumnDefinition from '../ColumnDefinition.js';
import KpiDefinition from "vcomponents/listing/apiListing/KpiDefinition";
import moment from 'moment';
import AutocompleteFilterDefinition from "../filtersDefinition/AutocompleteFilterDefinition";
import CheckboxFilterDefinition from "vcomponents/listing/apiListing/filtersDefinition/CheckboxFilterDefinition";
import StaffsFilterDefinition from "vcomponents/listing/apiListing/filtersDefinition/StaffsFilterDefinition";
import RelatedTypesFilterDefinition from "vcomponents/listing/apiListing/filtersDefinition/RelatedTypesFilterDefinition";



export default {
    defaultSort: { field: 'due_date', direction: 'desc' },
    columns: [
        new ColumnDefinition(
            'author',
            i18n.__('Responsable'),
            false,
            true,
            function (author) {
                return {
                    type: "component",
                    name: "person-list",
                    params: {
                        list: [
                            {
                                id: author.id,
                                staffid:  author.id,
                                type: "staff",
                                fullName: author.firstname+' '+author.lastname,
                                firstname: author.firstname,
                                lastname: author.lastname,
                                email: author.email,
                                status: author.status,
                                avatar: author.avatar !== null
                                    ? {
                                        type: "picture",
                                        value: author.avatar,
                                        class: 0
                                    }
                                    : {},
                            }
                        ],
                        placeholder: i18n.__('Responsable')
                    }
                };
            }
        ),
        new ColumnDefinition(
            'due_date',
            i18n.__("Date"),
            false,
            true,
            function(date) {
                return {
                    type: "component",
                    name: "date-value",
                    params: {
                        value: new moment(date).unix(),
                    }
                };
            }
        ),
        new ColumnDefinition(
            'event',
            i18n.__('Type'),
            false,
            true,
            function (event) {
                if (event === 'task.created') {
                    // task.created with status completed is in fact a task.completed
                    event = 'task.completed';
                }
                return {
                    type: "component",
                    name: "event-value",
                    params: {
                        value: event,
                    }
                };
            }
        ),
        new ColumnDefinition(
            'more.label',
            i18n.__('Label'),
            false,
            true,
            function (more) {
                if (more.label === undefined) {
                    return '';
                }

                return this.metas.formatedLabels[more.label] !== undefined ?
                    this.metas.formatedLabels[more.label] :
                    '';
            },
            {
                sortableKey: 'more.label',
                prop: 'more'
            }
        ),
        new ColumnDefinition(
            'companies',
            i18n.__('Société'),
            false,
            false,
            function (companies) {
                const format = {
                    type: "component",
                    name: "person-list",
                    params: {
                        list: [],
                        placeholder: i18n.__('Société')
                    }
                };
                companies.forEach((company) => {
                    format.params.list.push({
                        id: company.id,
                        thirdid: company.id,
                        type: "third",
                        fullName: company.name,
                        relationType: company.type
                    });
                })
                return format;
            }
        ),
        new ColumnDefinition(
            'people',
            i18n.__('Contact'),
            false,
            false,
            function (people) {
                const format = {
                    type: "component",
                    name: "person-list",
                    params: {
                        list: [],
                        placeholder: i18n.__('Société')
                    }
                };
                if (people == null) return format;

                format.params.list.push({
                    id: people.id,
                    type: people.type,
                    fullName: people.name,
                    peopleid: people.id,
                });

                return format;
            }
        ),
        new ColumnDefinition(
            'related',
            i18n.__('Objet'),
            false,
            false,
            function (object) {
                return {
                    type: "component",
                    name: "object-value",
                    params: {
                        type: object.type,
                        id: object.id,
                        name: object.name,
                        placeholder: ''
                    }
                };
            }
        ),
        new ColumnDefinition(
            'more.status',
            i18n.__("Résultat d'appel"),
            false,
            false,
            function (more) {
                if (more.status === undefined) {
                    return '';
                }
                const status = this.metas.phonecall.statuses.find(status => {
                    return status.id == more.status
                });
                if (status != undefined) {
                    return status.label;
                }
                return '';
            },
            {
                prop: 'more'
            }
        ),
        new ColumnDefinition(
            'more.participants',
            i18n.__('Collaborateur(s)'),
            false,
            true,
            function (more) {
                const format = {
                    type: "component",
                    name: "person-list",
                    params: {
                        list: [],
                        placeholder: i18n.__('Collaborateur(s)')
                    }
                };
                if (more === null || more === undefined || more.participants === null || more.participants === undefined) return format;
                more.participants.forEach((staff) => {
                    format.params.list.push({
                        id: staff.id,
                        staffid: staff.id,
                        type: "staff",
                        fullName: staff.firstname + ' ' + staff.lastname,
                        firstname: staff.firstname,
                        lastname: staff.lastname,
                        email: staff.email,
                        status: staff.status,
                        avatar: staff.avatar !== null
                            ? {
                                type: "picture",
                                value: staff.avatar,
                                class: 0
                            }
                            : {},
                    });
                })
                return format;
            },
            { prop: 'more' }
        ),
    ],
    filters: [
        new DateIntervalDefinition('due_date', i18n.__("Période"), false),
        new AutocompleteFilterDefinition('companies', i18n.__("Société(s) liée(s)"), 'third'),
        new AutocompleteFilterDefinition('peoples', i18n.__("Contact(s) lié(s)"), 'people'),
        new StaffsFilterDefinition('authors', i18n.__("Collaborateur"), i18n.__("Collaborateurs affectés"), function () {
            return this.metas.authors;
        }),
        (new CheckboxFilterDefinition('events', i18n.__("Type d’activité"), function () {
            return [
                {
                    'id': ['email.sent', 'email.link.sent', 'email.scheduled.sent', 'emailengine.sent'],
                    'label': i18n.__('Email envoyé'),
                },
                {
                    'id': 'phonecall.created',
                    'label':  i18n.__('Appel passé'),
                },
                {
                    'id': 'event.created',
                    'label':  i18n.__('Evènement passé'),
                },
                {
                    'id': 'task.completed',
                    'label':  i18n.__('Tâche terminée'),
                },
            ]
        })),
        new RelatedTypesFilterDefinition('related.types', i18n.__("Objet lié")),
        (new CheckboxFilterDefinition('event.labels', i18n.__("Label de l'évènement"), function () {
            return this.metas.event.labels;
        }, true)).setGroup(i18n.__("Evènement")),
        (new CheckboxFilterDefinition('task.labels', i18n.__("Label de la tâche"), function () {
            return this.metas.task.labels;
        }, true)).setGroup(i18n.__("Tâche")),
        (new CheckboxFilterDefinition('phonecall.statuses', i18n.__("Résultat d'appel"), function () {
            return this.metas.phonecall.statuses;
        })).setGroup(i18n.__("Appel")),
        (new CheckboxFilterDefinition('phonecall.sources', i18n.__("Source d'appel"), function () {
            return this.metas.phonecall.sources;
        })).setGroup(i18n.__("Appel")),
        (new CheckboxFilterDefinition('phonecall.labels', i18n.__("Sujet d'appel"), function () {
            return this.metas.phonecall.labels;
        }, true)).setGroup(i18n.__("Appel")),
    ],
    hooks: {
        metas: function (metas) {
            const formattedLabels = {};
            for (const label of metas.task.labels) {
                formattedLabels[label.id] = label.label;
            }
            for (const label of metas.event.labels) {
                formattedLabels[label.id] = label.label;
            }
            for (const label of metas.phonecall.labels) {
                formattedLabels[label.id] = label.label;
            }
            metas.formatedLabels = formattedLabels;

            return metas;
        },
        fetch: function (data, state) {
            //Max date, now
            const now =  moment().toISOString();
            if (typeof data.filters['due_date'] === "undefined") {
                data.filters['due_date'] = { end: now }
            } else if (data.filters['due_date'].end == "undefined" || data.filters['due_date'].end > now) {
                data.filters['due_date'].end = now;
            }
        },
    },
    contextMenus: [ ],
    batchActions: [ ],
    kpis: [
        new KpiDefinition('by_event.total', 'by_event', i18n.__('Total'), function (kpis) {
            const total = Object.values(kpis).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            return i18n.n__('%s activité', '%s activités', total, total);
        }),
        new KpiDefinition('by_event.email', 'by_event',  i18n.__('Emails'), function (kpis) {
            const emailSent = kpis.hasOwnProperty('email.sent') ? kpis['email.sent'] : 0;
            const emailLinkSent = kpis.hasOwnProperty('email.link.sent') ? kpis['email.link.sent'] : 0;
            const emailengineSent = kpis.hasOwnProperty('emailengine.sent') ? kpis['emailengine.sent'] : 0;
            const emailScheduledSent = kpis.hasOwnProperty('email.scheduled.sent') ? kpis['email.scheduled.sent'] : 0;
            return emailSent + emailLinkSent + emailengineSent + emailScheduledSent;
        }),
        new KpiDefinition('by_event.phonecall',  'by_event',   i18n.__('Appels'), function (kpis) {
            return kpis.hasOwnProperty('phonecall.created') ? kpis['phonecall.created'] : 0;
        }),
        new KpiDefinition('by_event.task', 'by_event', i18n.__('Tâches'), function (kpis) {
            // task.created with status completed is in fact a task.completed
            return kpis.hasOwnProperty('task.created') ? kpis['task.created'] : 0;
        }),
        new KpiDefinition('by_event.event', 'by_event', i18n.__('Agenda'), function (kpis) {
            return kpis.hasOwnProperty('calendar_event.created') ? kpis['calendar_event.created'] : 0;
        }),
    ]
}
